import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowRight } from "lucide-react";
import { COMPANY, SERVICES } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-20">
      <div className="lis-container py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={COMPANY.logo} alt="LIS" className="h-14 md:h-16 w-auto object-contain bg-white rounded-lg px-3 py-2" />
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            End-to-end ISO consulting, training and certification support. Trusted by manufacturers, IT, healthcare, food and laboratories across India and abroad.
          </p>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Popular Services</div>
          <ul className="space-y-2 text-sm">
            {SERVICES.slice(0, 7).map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="hover:text-white flex items-center gap-2">
                  <ArrowRight size={12} className="text-brand" /> {s.code}  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About LIS</Link></li>
            <li><Link to="/industries" className="hover:text-white">Industries</Link></li>
            <li><Link to="/training" className="hover:text-white">Training</Link></li>
            <li><Link to="/toolkit" className="hover:text-white">Toolkits</Link></li>
            <li><Link to="/case-studies" className="hover:text-white">Case Studies</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog & Insights</Link></li>
            <li><Link to="/careers" className="hover:text-white">Careers</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-brand mt-1 flex-shrink-0" />
              <span>{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-brand" />
              <div className="flex flex-col">
                <a href={`tel:${COMPANY.phones[0].replace(/\s/g, "")}`} className="hover:text-white">{COMPANY.phones[0]}</a>
                <a href={`tel:${COMPANY.phones[1].replace(/\s/g, "")}`} className="hover:text-white">{COMPANY.phones[1]}</a>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-brand" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="lis-container py-5 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500 gap-2">
          <div>{new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="flex items-center gap-5 flex-wrap">
            <Link to="/portal/login" className="hover:text-white">Client Portal</Link>
            <Link to="/admin/login" className="hover:text-white">Admin</Link>
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
